Initialize_Viewer()

function Initialize_Viewer() {
    let count = 0
    for (image of Image_List()) {
        image.addEventListener("click", Open_Slideshow);
        image.setAttribute("data-viewer-id", count)
        count += 1
    }

    document.getElementById("slideshow-full-prev").addEventListener("click", Previous_Slide)
    document.getElementById("slideshow-full-next").addEventListener("click", Next_Slide)
    document.getElementById("slideshow-full-close").addEventListener("click", Close_Slideshow)
}


function Open_Slideshow(event) {
    document.getElementById("slideshow-fullscreen").classList.remove("hidden")
    let image_target = event.target;
    Update_Slideshow_Image(image_target)

}
function Get_SRC(image_target) {

    if (image_target.getAttribute("srcset") != undefined) {
        return image_target.getAttribute("srcset").split("?")[0];
    }

    if (image_target.getAttribute("src") != undefined) {
        return image_target.getAttribute("src").split("?")[0];
    }

    let imgfirstChild = image_target.querySelector("img")

    if (image_target.classList.contains("media") && imgfirstChild != undefined) {
        if (imgfirstChild.getAttribute("srcset") != undefined) {
            return imgfirstChild.getAttribute("srcset").split("?")[0];
        }

        if (imgfirstChild.getAttribute("src") != undefined) {
            return imgfirstChild.getAttribute("src").split("?")[0];
        }
    }
}

function Update_Slideshow_Image(image_target) {
    let frame = document.getElementById("slideshow-full-frame")
    let src_url = Get_SRC(image_target)
    let caption = document.getElementById("slideshow-caption").querySelector("span")

    if (src_url != undefined) {
      frame.setAttribute("src", src_url)
      frame.parentElement.style.backgroundColor = "transparent"
      frame.classList.remove("hidden")
  
      let progress = document.getElementById("slideshow-full-progress")
      progress.classList.remove("hidden")
      caption.classList.add("hidden")
      
      frame.addEventListener("load",()=> { 
          document.getElementById("slideshow-full-progress").classList.add("hidden")
          document.getElementById("slideshow-caption").querySelector("span").classList.remove("hidden")
       })
      
    }else{
      const computedStyle = window.getComputedStyle(image_target);
      const backgroundColor = computedStyle.getPropertyValue('background-color');
      frame.parentElement.style.backgroundColor = backgroundColor
      frame.classList.add("hidden")
      document.getElementById("slideshow-caption").querySelector("span").classList.remove("hidden")
    }
  
    let data_id = image_target.closest("[data-viewer-id]").getAttribute("data-viewer-id")
    frame.setAttribute("data-viewer-id", data_id)
    if (frame.setAttribute("alt", image_target.closest("[alt]"))!=undefined){
        frame.setAttribute("alt", image_target.closest("[alt]").getAttribute("alt"))

    }
    caption.innerHTML = `${Number(data_id) + 1} of ${Image_List().length}`

}

function Image_List() {
    return document.querySelectorAll("main :not(a) > :not(a) > :not(a) > :not(a) > div.media[srcset], main :not(a) > :not(a) > :not(a) > :not(a) > div.media[src], main :not(a) > :not(a) > :not(a) > :not(a) > div.media")
}

function Next_Slide(event) {
    let image_list = Image_List()
    let count = Number(document.getElementById("slideshow-full-frame").getAttribute("data-viewer-id")) + 1
    console.log(count)
    if (count >= image_list.length) {
        //wrap around
        Update_Slideshow_Image(image_list[0])

    } else {
        Update_Slideshow_Image(image_list[count])
        console.log(image_list[count])
    }
}

function Previous_Slide(event) {
    let image_list = Image_List()
    let count = Number(document.getElementById("slideshow-full-frame").getAttribute("data-viewer-id")) - 1
    console.log(count)
    if (count < 0) {
        //wrap around
        Update_Slideshow_Image(image_list[image_list.length - 1])

    } else {
        Update_Slideshow_Image(image_list[count])
    }
}

function Close_Slideshow(event) {
    document.getElementById("slideshow-fullscreen").classList.add("hidden")
}